import { makeStyles } from "@material-ui/core/styles";

const useBaseStyle = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  card: {
    backgroundColor: "#1e1e1e",
    color: "white",
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  mediaPlaceholder: {
    height: 300,
    backgroundColor: "#333",
    borderRadius: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sidebarCard: {
    backgroundColor: "#131313",
    padding: theme.spacing(2),
  },
  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
  },
  sidebarTitle: {
    display: "flex",
    alignItems: "center",
    color: "white",
    gap: theme.spacing(1),
  },
  seeMore: {
    color: "#f06ec4",
    cursor: "pointer",
  },
  creatorItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
    },
  },
  creatorInfo: {
    display: "flex",
    alignItems: "center",
    color: "white",
    gap: theme.spacing(2),
  },
  followButton: {
    borderRadius: 5,
    borderColor: "#f06ec4",
    color: "#f06ec4",
    textTransform: "none",
    backgroundColor: "white",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "rgba(240, 110, 196, 0.08)",
      borderColor: "#f06ec4",
    },
    "&:focus": {
      outline: "none",
    },
    "&.Mui-focusVisible": {
      outline: "none",
    },
  },
  plusIcon: {
    color: "#f06ec4",
    marginRight: theme.spacing(1),
  },
  searchPanelContainer: {
    marginBottom: "25px",
  },
  avatar: {
    width: 40,
    height: 40,
  },
  CreatorSuggestions: {
    display: "flex",
    justifyContent: "flex-end",
    maxHeight: "1045px",
    maxWidth: 400,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "flex-start",
      width: "100%",
      maxWidth: "100%",
      maxHeight: "none",
    },
  },
}));

export default useBaseStyle;
